import type { DisclosureContentProps } from '@ariakit/react';
import { Dialog as AriakitDialog } from '@ariakit/react';

type Props = {
  backdropProps?: Omit<DisclosureContentProps<'div'>, 'state'>;
  children?: React.ReactNode;
  className?: string;
  isOpen: boolean;
  onDismiss: () => void;
};

export const Dialog = ({ className, isOpen, onDismiss, children }: Props) => {
  return (
    <AriakitDialog
      className={`fixed top-0 z-50 flex size-full items-center justify-center`}
      onClose={onDismiss}
      open={isOpen}
      onClick={onDismiss}
      backdrop={<div className="bg-black/50" />}
    >
      <div
        className={className}
        role="button"
        tabIndex={0}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.stopPropagation();
          }
        }}
      >
        {children}
      </div>
    </AriakitDialog>
  );
};

export { DialogDismiss } from '@ariakit/react/dialog';
